var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSensory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.714,
    height: 120.714,
    viewBox: "0 0 120.714 120.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-sensory-shapes-3791338",
    transform: "translate(-10.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_475",
    "data-name": "Caminho 475",
    d: "M233,56H139.7a13.723,13.723,0,0,0-13.708,13.708v41.549A13.724,13.724,0,0,0,139.7,124.966H233a13.724,13.724,0,0,0,13.708-13.708V69.708A13.723,13.723,0,0,0,233,56Zm10.691,55.256A10.7,10.7,0,0,1,233,121.946H139.7a10.7,10.7,0,0,1-10.691-10.69V69.707A10.7,10.7,0,0,1,139.7,59.016H233a10.7,10.7,0,0,1,10.691,10.691Z",
    transform: "translate(-115.507 -56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_476",
    "data-name": "Caminho 476",
    d: "M403.594,112.12H384.958a9.774,9.774,0,0,0-9.762,9.763v18.635a9.774,9.774,0,0,0,9.762,9.763h18.636a9.774,9.774,0,0,0,9.762-9.763V121.882A9.774,9.774,0,0,0,403.594,112.12Zm6.745,28.4a6.751,6.751,0,0,1-6.745,6.745H384.958a6.752,6.752,0,0,1-6.745-6.745V121.881a6.751,6.751,0,0,1,6.745-6.745h18.636a6.752,6.752,0,0,1,6.745,6.745Z",
    transform: "translate(-297.561 -96.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_477",
    "data-name": "Caminho 477",
    d: "M191.814,105.589a1.51,1.51,0,0,0-1.775,0l-19.414,14.105a1.508,1.508,0,0,0-.548,1.687l7.415,22.822a1.509,1.509,0,0,0,1.436,1.043h24a1.509,1.509,0,0,0,1.436-1.043l7.415-22.822a1.508,1.508,0,0,0-.548-1.687Zm10.016,36.64H180.025l-6.737-20.737,17.64-12.817,17.64,12.817Z",
    transform: "translate(-147.657 -92.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_478",
    "data-name": "Caminho 478",
    d: "M403.594,400.534a9.774,9.774,0,0,0,9.762-9.763V372.135a9.774,9.774,0,0,0-9.762-9.763H384.958a9.774,9.774,0,0,0-9.762,9.763v18.635a9.774,9.774,0,0,0,9.762,9.762Zm-25.381-9.763V372.135a6.751,6.751,0,0,1,6.745-6.745h18.636a6.752,6.752,0,0,1,6.745,6.745v18.635a6.752,6.752,0,0,1-6.745,6.746H384.958A6.753,6.753,0,0,1,378.214,390.771Z",
    transform: "translate(-297.561 -279.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_479",
    "data-name": "Caminho 479",
    d: "M178.922,395.494h24a1.509,1.509,0,0,0,1.436-1.043l7.415-22.822a1.508,1.508,0,0,0-.548-1.687l-19.414-14.106a1.51,1.51,0,0,0-1.775,0L170.619,369.94a1.508,1.508,0,0,0-.548,1.687l7.415,22.822a1.509,1.509,0,0,0,1.436,1.044Zm12-36.573,17.64,12.817-6.737,20.737h-21.8l-6.737-20.737Z",
    transform: "translate(-147.653 -274.834)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensory);
export default __webpack_public_path__ + "static/media/sensory.f57480d6d5e660b2aed8435fe39e3eee.svg";
export { ForwardRef as ReactComponent };